const defaultState = {
  isLoaded: false,
  isLogined: false,
  profile: {},
  languages: [],
  stats: {
    totalQuestions: 0,
    activePresentations: 0,
    flashcardDecks: 0,
    activeLearning: 0,
    sliders: 0,
  }
}

const auth = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_PROFILE':
      return {
        ...state,
        profile: action.data,
        isLogined: true,
        isLoaded: true,
      };
    case 'IS_LOADED':
      return {
        ...state,
        isLoaded: action.data,
      };
    case 'SET_AUTH_KEY':
      return {
        ...state,
        [action.key]: action.data,
      };
    case 'LOGOUT':
      return {
        ...state,
        isLoaded: true,
        isLogined: false,
        profile: {}
      };
    default:
      return state
  }
}

export default auth;
